import { RouterConfig } from "@shared/lib/routerConfig";
import { ReportDownloadCardProps } from "./types";
import classes from "./report-download-card.module.scss";

export const ReportDownloadCard = ({ brand, model, year, vin, slug }: ReportDownloadCardProps) => {
    const title = `${brand} ${model}, ${year}`;

    const handleDownload = () => {
        if (!slug) return;
        window.open(`${RouterConfig.HISTORY}/report/${slug}?pdf=download`, "_blank");
    };

    return (
        <div className={classes["report-download"]}>
            <div className={classes["report-download__title"]}>{title}</div>
            <div className={classes["report-download__vin"]}>{vin}</div>
            <button
                type="button"
                className={classes["report-download__button"]}
                onClick={handleDownload}
            >
                Скачать PDF
            </button>
        </div>
    );
};